import React, { useState, useEffect, KeyboardEvent } from "react";
import { useTranslation } from "react-i18next";

import { PAGE_NUMBER_OPTIONS } from "../../../config";
import { InputBox } from "../../FormElement/InputBox";
import ToggleBtns from "../../ToggleBtns";
import "../../FacilityListComponents/ListTopBar/styles.scss";

export interface IInternalLabelsListTopBarProps {
  filterFormData: any;
  onChangeFilterFormData: (filterFormData: any) => void;
}

const InternalLabelsListTopBar: React.FC<IInternalLabelsListTopBarProps> = ({
  filterFormData,
  onChangeFilterFormData,
}) => {
  const { t } = useTranslation();
  const [searchName, setSearchName] = useState<string>(
    filterFormData?.searchName || ""
  );

  useEffect(() => {
    setSearchName(filterFormData?.searchName || "");
  }, [filterFormData?.searchName]);

  return (
    <div className="list-top-bar flex-grid">
      <div className="lefts">
        <div className="filter-wrap">
          <div className="filter-some-block"></div>
        </div>
      </div>
      <div className="rights flex">
        <div className="search-module">
          <div className="top-txt">&nbsp;</div>
          <InputBox
            value={searchName}
            placeholder={t(
              "internalLabelsManagementPage.internalLabelsList.search_by_name"
            )}
            isSearch={true}
            classNameContainer={"search-input"}
            onChange={(value: string) => {
              setSearchName(value);
            }}
            onKeyPress={(event: KeyboardEvent<HTMLInputElement>) => {
              if (event.key === "Enter") {
                onChangeFilterFormData({
                  ...filterFormData,
                  searchName: searchName,
                  pageIndex: 1,
                });
              }
            }}
          />
        </div>
        <div className="choose-area">
          <div className="top-txt">
            {t(
              "internalLabelsManagementPage.internalLabelsList.number_per_page"
            )}
          </div>
          <ToggleBtns
            selectedValue={filterFormData.numberPerPage}
            options={PAGE_NUMBER_OPTIONS}
            onClickBtn={(option: number) => {
              onChangeFilterFormData({
                ...filterFormData,
                numberPerPage: option,
                pageIndex: 1,
              });
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default InternalLabelsListTopBar;
